import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { usageMeasurementIsAllowed } from './domains/the-usage-measurement-switch';

/**
 * Tells the API that a push was touched, so the right time to send can be
 * worked out (Hooked 3). The API keeps the last open and a count per hour of
 * the day, nothing more; see a-push-open.ts on the API side.
 *
 * NOTHING LEAVES THE PHONE for a member who refused the usage measurement.
 * The API checks the account's refusal too, but a refusal made on this phone
 * and not yet carried to the account must already be respected here.
 *
 * Fired and forgotten: opening the notification never waits on it, and no
 * failure is shown or thrown. An API older than this route answers 404, which
 * is swallowed like the rest.
 */
@Injectable({ providedIn: 'root' })
export class PushOpenReporter {
  private readonly http = inject(HttpClient);

  /** Ten seconds; nobody waits on it, it only must not hang for ever. */
  private static readonly PATIENCE = 10000;

  report(type: unknown, now: Date = new Date()): void {
    try {
      if (!usageMeasurementIsAllowed()) {
        return;
      }
      this.http
        .post(`${environment.api}/api/v1/profile/push-opened`, {
          type: typeof type === 'string' ? type : undefined,
          openedAt: now.toISOString(),
        })
        .pipe(timeout(PushOpenReporter.PATIENCE))
        .subscribe({ error: () => undefined });
    } catch {
      // Nothing a member asked for depends on this call.
    }
  }
}
